import { addToCart, getCart, setCartCount, toProductVariantGid } from './cart/cart.service';
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cart-product-variant-id]').forEach(el => {
        el.addEventListener('click', async () => {
            el.classList.add('is-loading');
            addToCart(toProductVariantGid(el.getAttribute('data-cart-product-variant-id'))).finally(() => el.classList.remove('is-loading'));
        });
    });
    // Update cart amount upon startup
    getCart().then(cart => setCartCount(cart?.lines?.edges?.length ?? 0));
});
